export default __webpack_public_path__ + "static/media/inclusion.ec00c49c.png";